var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}

/* eslint react/prop-types: 0 */
import * as R from 'ramda';
import React, { useEffect, useMemo, useState } from 'react';
import { getHierarchicalId } from './utils';
export var spotlightFilter = function spotlightFilter(term) {
  var labelRenderer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : R.prop('label');
  return function (items) {
    if (R.isEmpty(term) || R.isNil(term)) {
      return items;
    }
    var groupedItemsByParentId = R.groupBy(R.propOr('#ROOT', 'parentId'), items);
    var recurse = R.filter(function (item) {
      var isValidItem = R.isEmpty(term) || R.isNil(term) ? true : R.includes(R.toLower(term), R.toLower(labelRenderer(item)));
      if (isValidItem) {
        return true;
      }
      if (R.has(getHierarchicalId(item), groupedItemsByParentId)) {
        var filtered = recurse(R.prop(getHierarchicalId(item), groupedItemsByParentId));
        if (!R.isEmpty(filtered)) {
          return true;
        }
      }
      return false;
    });
    return recurse(items);
  };
};
var withSpotlight = function withSpotlight(Component) {
  return function (_ref) {
    var items = _ref.items,
      defaultSpotlight = _ref.defaultSpotlight,
      labelRenderer = _ref.labelRenderer,
      rest = _objectWithoutProperties(_ref, ['items', 'defaultSpotlight', 'labelRenderer']);
    var _useState = useState({
        term: ''
      }),
      term = _useState[0].term,
      setSpotlight = _useState[1];
    useEffect(function () {
      if (!R.isNil(defaultSpotlight) && !R.isEmpty(defaultSpotlight)) {
        setSpotlight(defaultSpotlight);
      }
    }, [defaultSpotlight]);
    var filteredItems = useMemo(function () {
      return spotlightFilter(term, labelRenderer)(items);
    }, [term, items]);
    return React.createElement(Component, _extends({}, rest, {
      allItems: items,
      items: filteredItems,
      labelRenderer: labelRenderer,
      hasSpotlight: R.length(items) >= 8,
      spotlight: {
        term: term
      },
      setSpotlight: setSpotlight
    }));
  };
};
export { withSpotlight };